import { ApiResult } from '@src/api/apiClient/apiResult';
import { axiosClient } from '@src/api/apiClient/axiosClient';

import { BookmarkItem, BookmarkToggleResponse } from '../../types/bookmark';
import { Pagination } from '../../types/pagination';

type BookmarkIndexRequest = {
  page?: number;
};

type BookmarkIndexResponse = {
  data: BookmarkItem[];
  pagination: Pagination;
};

export const bookmarkApiClient = {
  index: async (params: BookmarkIndexRequest = {}): Promise<ApiResult<BookmarkIndexResponse>> => {
    return await axiosClient.get('/company/bookmarks', { params });
  },
  toggle: async (articleId: number): Promise<ApiResult<BookmarkToggleResponse>> => {
    return await axiosClient.post(`/company/articles/${articleId}/bookmark`, {});
  },
};
